import styled from 'styled-components';

const TextWithHighlightedSearchWrapper = styled.span`
  max-width: 100%;
`;


export default { TextWithHighlightedSearchWrapper };
